const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Civil extends Technology {
    constructor(age, techName, scienceCost, civilActions, blueCubes){
        super(
            age,
            Civil.GetType(),
            techName,
            scienceCost,
            null,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.civilActionCalculationDelegate.push({
                            Source: this,
                            Action: () => civilActions,
                        });
                        // Extra blue tokens while in play; a newer civil technology replaces this one, so its
                        // tokens replace these (only the difference is gained)
                        playerState.blueTokenCalculationDelegate.push({
                            Source: this,
                            Action: () => blueCubes,
                        });
                    }
            }
        )
    }
    static GetType = () => TechnologyTypes.Special.Civil;
}

class CodeOfLaws extends Civil {
    constructor(){
        super(CodeOfLaws.GetAge(), CodeOfLaws.GetName(), 6, 1, 0)
    }

    static GetInstance = () => new CodeOfLaws();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Special.CodeOfLaws;
}

class JusticeSystem extends Civil {
    constructor(){
        super(JusticeSystem.GetAge(), JusticeSystem.GetName(), 7, 1, 3)
    }

    static GetInstance = () => new JusticeSystem();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Special.JusticeSystem;
}

class CivilService extends Civil {
    constructor(){
        super(CivilService.GetAge(), CivilService.GetName(), 10, 2, 3)
    }

    static GetInstance = () => new CivilService();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Special.CivilService;
}

module.exports = {
    CodeOfLaws,
    JusticeSystem,
    CivilService
}